import * as React from "react";

function SvgPendingSmall(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={15} height={15} {...props}>
      <path
        d="M7.5 0a7.451 7.451 0 00-5.3 2.2A7.452 7.452 0 000 7.5a7.451 7.451 0 002.2 5.3A7.451 7.451 0 007.5 15a7.452 7.452 0 005.3-2.2A7.451 7.451 0 0015 7.5a7.451 7.451 0 00-2.2-5.3A7.451 7.451 0 007.5 0zm0 13.946a6.409 6.409 0 01-2.508-.505 6.459 6.459 0 01-2.049-1.382 6.416 6.416 0 01-1.382-2.049 6.4 6.4 0 01-.506-2.51 6.415 6.415 0 01.505-2.508 6.471 6.471 0 011.382-2.049 6.416 6.416 0 012.049-1.382A6.4 6.4 0 017.5 1.054a6.405 6.405 0 012.508.506 6.46 6.46 0 012.049 1.381 6.421 6.421 0 011.382 2.05 6.4 6.4 0 01.507 2.509 6.4 6.4 0 01-.506 2.508 6.447 6.447 0 01-1.381 2.049 6.42 6.42 0 01-2.05 1.382 6.4 6.4 0 01-2.509.506zM7.5 2.8a.587.587 0 00-.586.586v5.405a.587.587 0 00.586.586.587.587 0 00.586-.586V3.386A.587.587 0 007.5 2.8zm0 7.515a.66.66 0 00-.659.659.66.66 0 00.659.659.66.66 0 00.659-.659.66.66 0 00-.659-.661z"
        fill="#ff9800"
      />
    </svg>
  );
}

export default SvgPendingSmall;
